export class UsageDetail {
  public id: number;
  public usageId: number;
  public tag: string;
  public modelAction: number;
  public rowStatus: boolean;
}
